import moment from 'moment';

// The applied-filter chips exactly as the page shows them ("City: Boston", "In business") — the
// readable labels ChipsList already worked out, rather than the query params behind them.
export const readFilterChips = (root = document) =>
  Array.from(root.querySelectorAll('.chip_text'))
    .map((chip) => chip.textContent.replace(/\s+/g, ' ').trim())
    .filter(Boolean);

// Characters no common file system accepts in a name, plus control characters.
// eslint-disable-next-line no-control-regex
const UNSAFE = /[\\/:*?"<>|\u0000-\u001f]+/g;

const clean = (text) => text.replace(UNSAFE, ' ').replace(/\s+/g, ' ').trim();

// Keeps the name well under the 255-byte limit of most file systems, leaving room for the rest.
const MAX_FILTERS_LENGTH = 120;

/** As many chips as fit, then "+N more" for the rest. */
const filtersPart = (chips) => {
  const parts = [];
  let length = 0;
  for (let i = 0; i < chips.length; i += 1) {
    const chip = clean(chips[i]);
    const rest = chips.length - i - 1;
    const suffix = rest > 0 ? ` +${rest} more` : '';
    if (parts.length && length + chip.length + 2 + suffix.length > MAX_FILTERS_LENGTH) {
      return `${parts.join(', ')} +${chips.length - i} more`;
    }
    parts.push(chip);
    length += chip.length + 2;
  }
  return parts.join(', ');
};

/** "Retailers - City Boston, In business - 2026-10-05.pdf" */
const pdfFileName = (title, chips = [], date = new Date()) => {
  const parts = [clean(title || '') || 'Export'];
  const filters = filtersPart(chips.filter(Boolean));
  if (filters) parts.push(filters);
  parts.push(moment(date).format('YYYY-MM-DD'));
  return `${parts.join(' - ')}.pdf`;
};

export default pdfFileName;
